import { Flex, Text } from "@radix-ui/themes";
import Link from "next/link";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { navigationMenuTriggerStyle } from "../ui/navigation-menu";
import { useState } from "react";
import { Role } from "@prisma/client";
import { signOut } from "next-auth/react";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import { ChevronDownIcon } from "@radix-ui/react-icons";

const AuthStatusButton = ({
  session,
  navButtonStyle,
}: {
  session: any;
  navButtonStyle: string;
}) => {
  const [loggingOut, setLoggingOut] = useState(false);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Flex
          align="center"
          className={cn(navigationMenuTriggerStyle(), navButtonStyle, "gap-1")}
        >
          <Text>
            Account
          </Text>
          <ChevronDownIcon />
        </Flex>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          <Text size="2">{session!.user!.email}</Text>
        </DropdownMenuLabel>
        {session.role === Role.BUYER && (
          <>
            <DropdownMenuItem asChild>
              <Link href="/watchlist">Watchlist</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link href="/account/details">Account Settings</Link>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuItem asChild>
          <Flex
            justify="between"
            align="center"
            onClick={() => {
              setLoggingOut(true);
              signOut({ callbackUrl: "/" });
            }}
          >
            <Text>Log Out</Text>
            {loggingOut && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          </Flex>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AuthStatusButton;
